import angular from "angular";

angular
	.module('app')
	.component('contractUsers', {
		template: require('./contract-users.html'),
        controller: ['$http', controller],
        bindings: {
            //
        }
    });
            
function controller($http) {
        
	let $ctrl = this;

    $ctrl.page = 1;
    $ctrl.perPage = '30';
    $ctrl.orderBy = 'date';
    $ctrl.orderDir = 'asc';
    $ctrl.search = '';

	$ctrl.$onInit = function () {
        $ctrl.getList();
    };

    $ctrl.getList = function () {
        $http
            .get('/admin/contract-users/get-list', {
                params: {
                    page: $ctrl.page,
                    search: $ctrl.search,
                    per_page: $ctrl.perPage,
                }
            })
            .then(res => {
                $ctrl.users = res.data.data;
                $ctrl.total = res.data.total;
            })
    };

    $ctrl.reset = function () {
        $ctrl.page = 1;
        $ctrl.search = null;
        $ctrl.getList();
    };

    $ctrl.doFilter = function () {
        $ctrl.page = 1;
        $ctrl.getList();
    };

    $ctrl.setOrderBy = function (orderBy) {
        if ($ctrl.orderBy === orderBy) {
            $ctrl.orderDir = $ctrl.orderDir === 'asc' ? 'desc' : 'asc';
        } else {
            $ctrl.orderBy = orderBy;
            $ctrl.orderDir = 'asc';
        }
        $ctrl.page = 1;
        $ctrl.getList();
    };
}